import * as yup from 'yup';
import { useForm } from 'vee-validate';
import { watch } from 'vue';
import { useStore } from 'vuex';
import debounce from 'lodash/debounce';

const ZIP_LENGTH = 5;
const DEBOUNCE_DELAY_MS = 350;

export const validationSchema = yup.object({
  address1: yup.string().required().label('Address'),
  city: yup.string().required().label('City'),
  state: yup.string().required().label('State'),
  zip: yup
    .string()
    .required()
    .min(ZIP_LENGTH)
    .max(ZIP_LENGTH)
    .test('IsNumeric', 'Should only contain digits', value => !isNaN(value))
    .label('Zip Code'),
});

const getFormData = defineComponentBinds => {
  const address1 = defineComponentBinds('address1');
  const address2 = defineComponentBinds('address2');
  const city = defineComponentBinds('city');
  const state = defineComponentBinds('state');
  const zip = defineComponentBinds('zip');

  return {
    address1,
    address2,
    city,
    state,
    zip,
  };
};

const watchDataChanges = (store, data) => {
  const updateState = key => debounce(val => store.commit(key, val.modelValue), DEBOUNCE_DELAY_MS);

  watch(data.address1, updateState('client/setAcctDetailAddress1'));
  watch(data.address2, updateState('client/setAcctDetailAddress2'));
  watch(data.city, updateState('client/setAcctDetailCity'));
  watch(data.state, updateState('client/setAcctDetailState'));
  watch(data.zip, updateState('client/setAcctDetailZip'));
};

const useConfirmAddressEditFormScript = () => {
  const store = useStore();
  const accountDetails = store.state.client.accountDetails;

  const initialValues = {
    address1: accountDetails.address1,
    address2: accountDetails.address2,
    city: accountDetails.city,
    state: accountDetails.state,
    zip: accountDetails.zip,
  };

  const { defineComponentBinds, errors, handleSubmit } = useForm({
    validationSchema,
    initialValues,
    validateOnMount: true,
  });

  const data = getFormData(defineComponentBinds);

  const submitForm = handleSubmit(async _values => {
    await store.dispatch('client/updateAccountDetails');
  });

  watchDataChanges(store, data);

  return {
    errors,
    data,
    submitForm,
  };
};

export default useConfirmAddressEditFormScript;
